import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=2d06f0c4&scoped=true&"
var script = {}
import style0 from "./PageContent.vue?vue&type=style&index=0&id=2d06f0c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06f0c4",
  null
  
)

export default component.exports